// @ts-ignore
import styles from './EducationMaterialFolder.module.scss';
import EducationMaterial from './EducationMaterial';
import { EducationMaterialInterface } from '../../Models/EducationMaterials/EducationMaterial';
import { useState } from 'react';

interface EducationMaterialFolder {
	data: {
		id: string;
		name: string;
		educationMaterials: [EducationMaterialInterface];
	};
	onUpdateItem: Function;
}

export default function EducationMaterialFolder(
	props: EducationMaterialFolder,
) {
	const { data, onUpdateItem } = props;
	const [materials, setMaterials] = useState(data.educationMaterials);

	const onUpdateMaterial = (item: EducationMaterialInterface) => {
		const currentMaterials = [...materials];
		for (const materialIndex in currentMaterials) {
			if (currentMaterials[materialIndex].key === item.key) {
				currentMaterials[materialIndex] = item;
			}
		}

		setMaterials(currentMaterials);
		onUpdateItem({ ...data, educationMaterials: materials });
	};

	return (
		<div className={styles.wrapper}>
			<div className={'d-flex flex-row align-items-center'}>
				<div className={styles.icon} />
				<div className={styles.title}>{data.name}</div>
			</div>
			<div className={'row'}>
				{materials &&
					materials.map((item, index) => (
						<div key={index} className={'col-lg-3 col-md-4 col-12'}>
							<EducationMaterial item={item} onUpdateItem={onUpdateMaterial} />
						</div>
					))}
			</div>
		</div>
	);
}
